// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"Q0esVa8eEdEGzxn6xalSk"};